/**
 * Shared configuration constants
 * These can be overridden via environment variables
 */

// Speech timing
export const SPEAK_TIMEOUT_MS = 30000 // 30 seconds max per speech item
export const RETRY_DELAY_MS = 1000 // 1 second between retries
export const MAX_SPEECH_RETRIES = 2

// Face verification
export const VERIFICATION_INTERVAL_MS = 5000 // Check face every 5 seconds
export const SILENCE_TIMEOUT_MS = 2500 // Wait 2.5 seconds of silence before processing

// Proctoring warnings
export const WARNING_COOLDOWN_MS = 15000 // 15 seconds between warnings
export const WARNING_ESCALATION_THRESHOLD = 3 // After 3 warnings of same type, escalate

// Rate limiting
export const RATE_LIMIT_REQUESTS = 60 // requests per window
export const RATE_LIMIT_WINDOW_MS = 60000 // 1 minute window

// Cache TTL
export const CACHE_TTL_SECONDS = 3600 // 1 hour
export const FACE_ENCODING_TTL_SECONDS = 24 * 60 * 60 // 24 hours

// Protocol version for postMessage communication
export const PROTOCOL_VERSION = 1
